import { LogOut, Menu } from 'lucide-react';
import { useState } from 'react';
import { authApi } from '../../api/auth';
import { useAuthStore } from '../../store/authStore';
import { ThemeToggle } from '../ui/ThemeToggle';

export function Header({ title = 'Overview', onMenu, navigationOpen = false }: { title?: string; onMenu?: () => void; navigationOpen?: boolean }) {
  const { user, logout } = useAuthStore();
  const [logoutError, setLogoutError] = useState('');
  const [loggingOut, setLoggingOut] = useState(false);
  const handleLogout = async () => {
    setLoggingOut(true);
    setLogoutError('');
    try { await authApi.logout(); logout(); }
    catch { setLogoutError('Sign-out failed. Please retry or use browser sign-out.'); }
    finally { setLoggingOut(false); }
  };
  return (
    <header className="app-header">
      <div className="header-context"><button className="shell-icon-button mobile-menu" type="button" onClick={onMenu} aria-label="Open navigation" aria-expanded={navigationOpen} aria-controls="app-navigation"><Menu size={21} /></button><div><p className="header-eyebrow">AwareNow workspace</p><p className="header-title">{title}</p></div></div>
      <div className="header-actions">{logoutError && <span role="alert">{logoutError} <a href="/logout">Browser sign-out</a></span>}<ThemeToggle /><div className="header-account"><span className="account-avatar" aria-hidden="true">{user?.username?.slice(0, 2).toUpperCase() || 'AN'}</span><div><strong>{user?.username}</strong><small>{user?.role?.name || 'Workspace member'}</small></div></div><button disabled={loggingOut} onClick={handleLogout} className="shell-icon-button" aria-label="Logout" title="Logout"><LogOut size={18} /></button></div>
    </header>
  );
}
